module.exports = __webpack_public_path__ + "85fbd5bd5f41579580f210134302a24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-penguin-hello.png
// module id = 2061
// module chunks = 4